import { EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const acceptedFileTypes = {
	[EMIMETypes.png]: ['.png'],
	[EMIMETypes.jpeg]: ['.jpeg', '.jpg'],
	[EMIMETypes.svg]: ['.svg'],
};

export const fileErrors = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Allowed extensions are png, svg, jpg, jpeg',
	[EDropzoneFileErrorCodes.fileTooLarge]: 'The file size must be less than 5MB',
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
};

export const supportsText = 'Supports: JPEG, JPG, PNG, SVG';

export const MAX_BYTES = 5e+6;

export const ASPECT = 1 / 1;

export const DEFAULT_WIDTH = 60;
export const DEFAULT_HEIGHT = 60;

export const SCALE = 1;

export const ROTATE = 0;

export const TO_RADIANS = Math.PI / 180;

export const DEBOUNCE_TIMEOUT = 100;
